//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      pager:{
        page: '1',
        pageCount: '1',

      },
      content:{},
      reply:[],
      parPage: '1',
      parCount: '4',
      listArrs : [],
      showHideOnBlur:false,
      imgsrc:'',
      assbtn:false
    }
  },
  mounted(){
    this.config()
  },
  methods: {
    async config() {
      this.gongdan = {'id': this.$route.params.id }
      this.GongdanQuery()
    },
    async GongdanQuery() {
      let data = 'cmd=gd_list'+
        '&key_type=id'+
        '&keyword='+ this.gongdan.id
      this.$http.post('https://api.abeiyun.com/www/gd.php',data).then(({data})=>{
        if(data.response==200){
          this.content = data.msg.content[0]
          this.assbtn = this.content.gd_pingjia === '0' ? false : true
          switch (this.content.gd_state) {
            case '0':
              this.content.state = '待分配'
              break
            case '1':
              this.content.state = '处理中'
              break
            case '2':
              this.content.state = '已答复'
              break
            case '3':
              this.content.state = '已结束'
              break
          }
          this.reply = data.gd_reply
        }
      })
    },
    ShowImg(src) {
      this.imgsrc = src
      this.showHideOnBlur = true
    },
    Reply() {
      this.$router.push('/user/workorreply/'+ this.gongdan.id)
    },
    Assess() {
      this.$router.push('/user/workorassess/'+ this.gongdan.id)
    },
    Tousu() {
      this.$vux.alert.show({
        title: '提示信息',
        content: '栏目建设中',
      })
    },
    GongdanClose() {
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '您确定关闭工单吗',

        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          let data = 'cmd=gd_close'+
            '&id_root=' + _this.gongdan.id
          _this.$http.post('https://api.abeiyun.com/www/gd.php',data).then(({data})=>{
            if(data.response==200){
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
                onHide () {
                  _this.GongdanQuery()
                }
              })
            }
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/workorder.vue